export default __webpack_public_path__ + "static/media/logo.03fe2c38.png";